const PlatformData = [
  
  
    {
        "id" : 1,
        "path": require("../../assets/img/resource-center/trainings-course.svg")
        .default,
        "platform" : "Training Courses",
        "engage-time" : "2 minutes engagement",
        "img-class" : "training-img",
        "platform_type": "TrainingWalkthrough",
        "url":"/learning-training-walkthrough"
    },
    {
        "id" : 2,
        "path": require("../../assets/img/resource-center/maturity-assessment.svg")
        .default,
        "platform" : "Maturity Assessment",
        "engage-time" : "3 minutes engagement",
        "img-class" : "",
        "platform_type": "AssessmentWalkthrough",
        "url":"/learning-assessment-walkthrough"
    },
    {
        "id" : 3,
        "path": require("../../assets/img/resource-center/loss-anylisis.svg")
        .default,
        "platform" : "Loss Analysis",
        "engage-time" : "3 minutes engagement",
        "img-class" : "",
        "platform_type": "LossWalthrough",
        "engage-class": "loss-text",
        "url":"/learning-loss-walkthrough"
    }
];

export default PlatformData;